/**
 * Contornos (máscaras) del hero, derivados de los SVG vectoriales del diseño
 * (`Vector 1.svg` / `Vector 2.svg`) y simplificados a curvas suaves (C1, sin
 * esquinas) para que el recorte se vea limpio.
 *
 * - `HOME`  → silueta de Inicio (foto corta a la izquierda, larga hacia la
 *   derecha): un único tramo cúbico suave.
 * - `PAGE`  → silueta de Quiénes somos y Contacto (doble onda): tres tramos
 *   cúbicos con tangentes continuas (sin puntas).
 */
export interface HeroWave {
  viewBox: string;
  d: string;
}

export const HERO_WAVE_HOME: HeroWave = {
  viewBox: "0 0 1920 865",
  d: "M1923 0H-6C-6 884.406 1280 922.554 1923 831.077V0Z",
};

export const HERO_WAVE_PAGE: HeroWave = {
  viewBox: "0 0 1920 806",
  d: "M 0 0 H 1920 V 570 C 1832 648 1620 806 1435 806 C 1252 806 1030 570 823 570 C 616 570 340 806 0 806 Z",
};
